import { TreatmentAiJobStatus } from './treatment-ai-job.model';

export interface RetainerAiJobSubmission {
    readonly jobId: string;
    readonly status: TreatmentAiJobStatus;
}
